/*
This page calls sidebar component (which shows the icons. So when clicked they are taken to respective page), navbar component ( which renders 
title of page, logged-in user's first name and a logout button) and PltVersionTable component (calls Updatedtime component (which prints last 
fetched data's date and time), VersionDownload component (which gives us a download button when clicked it gives us a downloaded version of that 
particular page in pdf format), this component also has table which renders the json data in table format).
*/

import PltVersionTable from "../components/PlatformDashboard/PltVersionTable";
import Navbar from "../components/NavBar/Navbar"
import SideNavBar from "../components/NavBar/SideBar"

const PltVersionPage = () =>{
    return (
        <div style={{ display: 'flex', width:'100% !important', position: 'fixed'}}>
            <SideNavBar />
            <div style={{  flex: 1, display: 'flex', flexDirection: 'column', }}>
                <div className="plt-page-nav">
                    <Navbar title="Platform Release Dashboard"/>
                </div>
                <PltVersionTable/>
            </div>
        </div>
    );
}

export default PltVersionPage;

